import { Pipe, PipeTransform } from "@angular/core";
import Big from "big.js";

/**
 * this pipe make use of the toFixed method
 * @param digits default value is set to 2.
 */
@Pipe({
	name: "toFixed",
	standalone: false
})
export class ToFixedPipe implements PipeTransform {
	public transform(value: string | number, digits: number = 2, trimZeros: boolean = false): string {
		const val = typeof value === "string" ? parseFloat(value) : value;
		const transformedValue = val.toFixed(digits);

		if (trimZeros) {
			// Remove zeros
			return transformedValue.replace(/\.?0+$/, "");
		}

		return transformedValue;
	}
}

@Pipe({
	name: "toFixedRound",
	standalone: false
})
export class ToFixedRoundPipe implements PipeTransform {
	public transform(value: string | number, digits: number = 2): number {
		if (!value) {
			return 0;
		}

		const parse = new Big(value).round(digits, 0);
		return parse.toNumber();
	}
}
